import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-detail-driver',
  templateUrl: './table-detail-driver.component.html',
  styleUrls: ['./table-detail-driver.component.scss']
})
export class TableDetailDriverComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
